import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaIntersectionDefinition } from './TypedDefinition'

export const SchemaIntersectionPlugin = createSchemaPlugin(
  'Schema.Intersection',
  SchemaIntersectionDefinition
)
